import { Module } from 'vuex'

interface DailyEffortsState {
  chartData: { labelChartData: number[]; dailyEffortsChartData: number[][]; maxEffort: number }
  chartSeries: any[]
  chartOptions: any
  hasData: boolean
}

export const dailyEffortsModule = (): Module<DailyEffortsState, any> => {
  return {
    namespaced: true,
    state: {
      chartData: { labelChartData: [], dailyEffortsChartData: [], maxEffort: 0 },
      chartSeries: [],
      chartOptions: {},
      hasData: false
    },
    mutations: {
      setChartData(
        state,
        chartData: { labelChartData: number[]; dailyEffortsChartData: number[][]; maxEffort: number }
      ) {
        state.chartData = chartData
      },
      setChartSeries(state, chartSeries: any[]) {
        state.chartSeries = chartSeries
      },
      setChartOptions(state, chartOptions: any) {
        state.chartOptions = chartOptions
      },
      setHasData(state, hasData: boolean) {
        state.hasData = hasData
      }
    },
    actions: {},
    getters: {
      chartData: state => state.chartData,
      chartSeries: state => state.chartSeries,
      chartOptions: state => state.chartOptions,
      hasData: state => state.hasData
    }
  }
}
